//ModiferMotDePassePage.js

import React, { useState, useEffect } from 'react';
import {
  TextField,
  Button,
  Container,
  Typography,
  Box
} from '@mui/material';
import axios from 'axios';
import '../CSS/MotDePassePage.css'; // Assurez-vous que le chemin est correct
import { useLocation } from 'react-router-dom';
import apiUrl from '../config';

const MotDePassePage = () => {
  const [email, setEmail] = useState('');
  const [nouveauMotDePasse, setNouveauMotDePasse] = useState('');
  const [confirmerMotDePasse, setConfirmerMotDePasse] = useState('');
  const [message, setMessage] = useState('');
  const location = useLocation();

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const emailParam = query.get('email');
    if (emailParam) {
      setEmail(emailParam);
    }
  }, [location.search]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (nouveauMotDePasse !== confirmerMotDePasse) {
      setMessage('Les mots de passe ne correspondent pas.');
      return;
    }
    try {
      const response = await axios.post(`${apiUrl}/reinitialiser-mot-de-passe`, {
        email,
        nouveauMotDePasse,
      });
      setMessage(response.data.message);
    } catch (error) {
      setMessage('Erreur lors de la réinitialisation du mot de passe.');
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Réinitialiser le mot de passe
        </Typography>
        <form onSubmit={handleSubmit} className="mot-de-passe-form">
          <TextField
            fullWidth
            label="Email"
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled
          />
          <TextField
            fullWidth
            label="Nouveau mot de passe"
            type="password"
            margin="normal"
            value={nouveauMotDePasse}
            onChange={(e) => setNouveauMotDePasse(e.target.value)}
            required
          />
          <TextField
            fullWidth
            label="Confirmer le mot de passe"
            type="password"
            margin="normal"
            value={confirmerMotDePasse}
            onChange={(e) => setConfirmerMotDePasse(e.target.value)}
            required
          />
          <Button type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 2 }}>
            Réinitialiser
          </Button>
          {message && <Typography color="error" sx={{ mt: 2 }}>{message}</Typography>}
        </form>
      </Box>
    </Container>
  );
};

export default MotDePassePage;
